module.exports = __webpack_public_path__ + "img/2023.704ce2dd.svg";